<template>
    <div class="background-image" :class="effectImage" :style="backgroundImage">

        <div v-if="overlay" class="background-image-overlay"></div>

    </div>
</template>

<script>
    export default {
        props: {
            opacity: {
                type: Boolean,
                default: false
            },
            opacitymedium: {
                type: Boolean,
                default: false
            },
        	parallax: {
        		type: Boolean,
                default: false
            },
            src: String,
            overlay: Boolean,
            background_position: {
                type: String,
                default: 'center center'
            }
        },

        computed: {
        	effectImage: function () {
        		let result = '';
        		if (this.parallax) result += 'parallax';
                if (this.opacity) result += ' opacity-black';
                if (this.opacitymedium) result += ' opacity-black-medium';
                return result;
            },
            backgroundImage: function () {
                if (_.isUndefined(this.src)) return;
                return 'background-image: url(' + this.src + '); background-position: ' + this.background_position + ';';
            }
        }
    }
</script>

<style lang="scss">
    .background-image{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;

        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;

        > .background-image-overlay{
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, .75);
        }
    }

    .opacity-black {
        &:after {
            content: '';
            position: absolute;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, .7);
        }
    }

    .opacity-black-medium {
        &:after {
            content: '';
            position: absolute;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, .4);
        }
    }

    .parallax {
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/BackgroundImage.vue